s<template>
  <div class="index">
    <div class="bg">
      <!-- 右侧导航 -->
      <div class="group-btn">
        <div class="btn-item" @click="goRule">活动规则</div>
        <div class="btn-item" @click="goPrize">我的礼品</div>
        <div class="btn-item" @click="goRanking">排行榜</div>
      </div>
      <!-- logo -->
      <div class="logo">
        <img
          :src="imgHost + 'logo.png'"
        />
      </div>
      <!-- 人数 -->
      <div class="person-number">
        <div class="number-box">
          <span>围观人数</span>
          <span>{{ actInfo.visitTotal || 0 }}</span>
        </div>
        <div class="number-box">
          <span>参与人数</span>
          <span>{{ actInfo.joinTotal || 0 }}</span>
        </div>
      </div>
      <!-- slogan -->
      <div class="slogan">
        <img
          :src="imgHost + 'slogan.png?v=2'"
        />
      </div>
      <div class="index_img1">
        <img
          :src="imgHost + 'index_img1.png?v=2'"
        />
      </div>
      <!-- 倒计时 -->
      <div class="endTime">
        <label v-if="timeStatus === 1">距离活动开始还剩</label>
        <label v-if="timeStatus === 2">距离活动结束还剩</label>
        <label v-if="timeStatus === 3">活动已结束</label>
        <template v-if="timeStatus === 1 || timeStatus === 2">
          <span>{{ countTime.d | formatTime }}</span
          >天<span>{{ countTime.h | formatTime }}</span
          >时<span>{{ countTime.m | formatTime }}</span
          >分
          <!-- <span>{{ countTime.s | formatTime }}</span
          >秒 -->
        </template>
      </div>
      <div class="tips">
        <p>活动时间：2021年6月8日-6月15日</p>
        参与文澜府跃龙门锦鲤小游戏,有机会清空<br />万元购物车，战队排行前三还有惊喜大奖哦！
      </div>
      <!-- 朗读按钮 -->
      <!-- <div class="index_btn">
        <div class="act_animate_shake_seesaw_config" @click="goVoice">我要朗读</div>
        <div class="act_animate_shake_seesaw_config" @click="goShare">呼朋唤友</div>
      </div> -->
      <div class="index_img2">
        <img
          :src="imgHost + 'index_img2.png?v=2'"
        />
      </div>
      <!-- 奖品展示 -->
      <div class="prize-item">
        <!-- <div class="title-bg">红星观山天铂·礼品展示</div> -->
        <div class="prize">
          <img :src="imgHost + 'prize.png?v=2'" >
          <!-- <p>兑换时间：5月17日-5月23日</p> -->
        </div>
      </div>
      <!-- 优惠券 -->
      <!-- <div class="coupon-item">
        <div class="title-bg"></div>
        <div class="prize">
          <img :src="imgHost + 'coupon.png?v=1'" >
          <div class="btn-coupon" @click="buyCoupon"><img :src="imgHost + 'coupon_btn.png?v=1'" ></div>
        </div>
      </div> -->
      <!-- 佣金排行榜 -->
      <!-- <div class="ranking-box">
        <div class="title-bg">佣金排行榜</div>
        <div class="ranking-item">
          <div class="ranking-list">
            <div class="list-item" v-for="(item, index) in commissionList" :key="'ranking' + index">
              <div class="rank">{{index + 1}}</div>
              <div class="head-img">
                <img :src="item.headImg" alt="">
              </div>
              <div class="name">{{item.nickName}}已获得{{item.commission}}元佣金！</div>
            </div>
            <div class="no-data" v-if="commissionList.length === 0">暂无数据</div>
          </div>
        </div>
      </div> -->
      <!-- 项目展示 -->
      <!-- <div class="pro-nav">
        <div class="nav" v-for="(item, index) in addressList" :key="index + 'address'" @click="chooseAddress(item.name)" :class="{active: addressIndex === index}">{{item.name}}</div>
      </div> -->
      <div class="pro-box" v-for="(item, index) in buildList" :key="index + 'img'">
        <div class="title-bg"></div>
        <div class="pro-card">
          <div class="pro-item">
            <div class="pro-l" :class="{choose: item.path}" >
              <img :src="imgHost + 'project' + (index + 1) + '.png?v=2'" alt="" />
              <!-- <div class="project-name">上坤·晶萃四季</div> -->
              <div class="project-xcx" v-if="item.path">
                <wx-open-launch-weapp
                  id="launch-btn"
                  username="gh_23d489737156"
                  :path="item.path"
                  @error="infoClick(7)"
                  @launch="infoClick(7)"
                >
                <script type="text/wxtag-template">
                  <style>
                    .xcx{
                      width: 149px;
                      height: 140px;
                    }
                  </style>
                  <div class="xcx"></div>
                </script>
                </wx-open-launch-weapp>
              </div>
            </div>
            <div class="pro-r">
              <div class="name">择址太仓主城区核心</div>
              <span>建面约91-125㎡绿色智慧家</span>
              <span>以现代美学艺术</span>
              <span>焕新主城人居高度</span>
              <div class="pro-btn">
                <div @click="clickNav(item.name, item.position)">一键导航</div>
                <div @click="clickCall(item.tel)">一键拨号</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tips-box">
        <div class="title">线下打卡文澜府<br />更享惊喜礼遇</div>
        <div class="content-box">
          <div class="title-bg"></div>
          <div class="txt1">抖音打卡</div>
          <div class="txt2">赢清空万元购物车大奖</div>
          <div class="txt3">和铁头哥哥一起打卡文澜府</div>
          <div class="txt4">录制抖音挑战</div>
          <div class="txt4">#太仓芯坐标@太仓文澜府</div>
          <div class="txt3">最高可获得</div>
          <div class="txt3">清空万元购物车大奖</div>
        </div>
      </div>
      <div class="index_img3">
        <img
          :src="imgHost + 'index_img4.jpg?v=2'"
        />
      </div>
      <!-- 二维码 -->
      <!-- <div class="code">
        <img
          :src="imgHost + 'code.jpg?v=1'"
        />
      </div> -->
      <!-- 我要推荐 一折抢购 -->
      <div class="btn-layer">
        <div @click="goShare()" class="left act_animate_shake_seesaw_config">组成战队</div>
        <div @click="goGame()" class="left act_animate_shake_seesaw_config">参与游戏</div>
      </div>
      
      <!-- <div class="xcx-box">
        <wx-open-launch-weapp
            id="launch-btn"
            username="gh_fc483df74bcc"
            path="/pages/pageA/popertyDetail/index?projectId=1298791108445544450"
            @error="infoClick(7)"
            @launch="infoClick(7)"
          >
          <script type="text/wxtag-template">
            <style>
              .xcx{
                width: 94px;
                height: 31px;
              }
            </style>
            <div class="xcx"></div>
          </script>
          </wx-open-launch-weapp>
      </div> -->
      <!-- 我的好友 -->
      <div
        class="rule-msg"
        v-show="showFriend"
        @click="showFriend = false"
        :class="{ fadeInUp: showFriend, fadeInDown: !showFriend }"
      >
        <div class="rule-layer">
          <div class="title-bg">我的好友</div>
          <div class="rule-box">
            <div class="list-item" v-for="(item, index) in myFriendList" :key="'friend' + index">
              <div class="rank">{{ index + 1 }}</div>
              <div class="head-img">
                <img :src="item.headImg" alt="">
              </div>
              <div class="name">{{item.nickName}}已通过你的召唤成功购买商品</div>
            </div>
            <div v-show="myFriendList.length === 0" class="no-data">暂无数据</div>
          </div>
        </div>
      </div>
      <BasePaySuccess></BasePaySuccess>
      <!-- 下滑提示 -->
      <div class="down-arrow" v-if="showMore">
        <img class="arrow-img animated bounce" src="http://assets.rurushishi.com/activies/zhgy-candy/down.png" alt="">
        <div class="down-text">下滑更多精彩内容</div>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox, Indicator } from "mint-ui";
import Vue from "vue/dist/vue.js";
export default {
  components: {
  },
  data() {
    return {
      countTime: {
        d: 0,
        h: 0,
        m: 0,
        s: 0,
      }, // 倒计时
      scrollTop: 400, // 隐藏下滑箭头高度
      showMore: true, // 是否显示下滑箭头
      actInfo: [], // 活动信息
      timeStatus: 0, // 活动时间状态
      addressIndex: 0, // 地区index
      addressList: [
        {
          name: '贵阳'
        },
        {
          name: '遵义'
        },
        {
          name: '郴州'
        },
        {
          name: '常德'
        },
        {
          name: '岳阳'
        },
        {
          name: '咸宁'
        }
      ], // 地区列表
      buildList: [
        {
          name: '阳光城文澜府营销中心',
          address: '太仓市城厢镇弇山西路116号阳光城文澜府营销中心',
          txt1: '读外校',
          txt2: '住低密度花园社区',
          txt3: '103-126㎡全铝模工艺筑品',
          txt4: '全城热销中',
          tel: '0512-88829888',
          position: '121.088198,31.45252',
          // path: '/page/mainPage/pages/entry/main?page_type=justHouseIndex&project_id=1355809523462492160',
        }
      ], // 项目展示列表
      chooseBuildList: [], // 选中地区
      commissionList: [], // 佣金排行列表
      myFriendList: [], // 我的好友
      showFriend: false, // 是否显示我的好友
      gameCounts: 0, // 剩余游戏次数
      canBuy: true, // 是否可以购买优惠券
      couponId: 2278, //购房券ID
    };
  },
  filters: {
    formatTime: function (value) {
      return value < 10 ? "0" + value : value;
    }
  },
  watch: {},
  computed:{
  },
  methods: {
    // 监听页面滑动事件
    handleScroll(){
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
      if (this.scroll > this.scrollTop) {
        this.showMore = false
      } else  {
        this.showMore = true
      }
    },
    // 页面埋点
    infoClick(sceneKey) {
      this.$httpdf.get(this.apiHost + 'info/click', { sceneKey: sceneKey })
    },
    // 切换城市
    chooseAddress(name = '贵阳') {
      this.chooseBuildList = [...this.buildList].filter(v=> v.city === name)
      this.addressIndex = this.addressList.findIndex(v=> v.name === name)
      if (this.addressIndex < 0) {
        this.chooseAddress()
      }
    },
    // 购买优惠券
    buyCoupon() {
      if(this.timeStatus === 1){
        MessageBox.alert("活动未开始！");
        return false
      } else if (this.timeStatus === 3){
        MessageBox.alert("活动已结束！");
        return false
      }
      if (!this.$infoId) {
        return this.$showModal("不在活动区域内");
      }
      if (this.canBuy) {
        this.$modal.drawForm.alert({ prizeId: this.couponId, isCoupon: true }).then(()=> {
          this.getIsReceived()
        })
      } else {
        MessageBox.alert('您已经领过购房圆梦金了！')
      }
    },
    //一折抢购
    goDraw() {
      this.infoClick(4)
      if(this.timeStatus === 1){
        MessageBox.alert("活动未开始！");
        return
      } else if (this.timeStatus === 3){
        MessageBox.alert("活动已结束！");
        return
      }
      if (!this.$infoId) {
        return this.$showModal("不在活动区域内");
      }
      if (this.gameCounts >= 1) {
        return this.$goPage("draw");
      } else {
        this.$modal.drawForm.alert()
      }
    },
    // 读语音
    goVoice() {
      if(this.timeStatus === 1){
        MessageBox.alert("活动未开始！");
        return
      } else if (this.timeStatus === 3){
        MessageBox.alert("活动火爆，奖品已全部发完，本次活动已结束。");
        return
      }
      if (!this.$infoId) {
        return this.$showModal("不在活动区域内");
      } else {
        this.$goPage(`voice`);
      }
    },
    //ip定位
    async getLocationByIp() {
      Vue.prototype.$infoId = undefined
      this.$util.cookie.remove('infoId')
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle",
      });
      let that = this;
      const data = await this.$httpdf.get(this.apiHost + 'user/getLocationByIp')
      Indicator.close();
      if (data.code == 0) {
        if (!data.data.curLocation) {
          //本地测试用====================================>>>>>
          // that.localCity = that.$root.curLocation.location;
          // that.isLocation = true;  //默认在区域内
          //<<<<<=============================================

          //如果没有curLocation，说明ip定位失败，调取gps定位
          await that.getLocationByGps();
        } else {
          Vue.prototype.$infoId = data.data.curLocation.infoId;
          // this.chooseAddress(data.data.curLocation.location)
          await this.getParticipate()
          console.log(
            `当前城市名称--->${data.data.curLocation.location}-----当前infoId--->${data.data.curLocation.infoId}`
          );
        }
      } else {
        MessageBox.alert(data.msg)
      }
    },
    //gps定位
    async getLocationByGps() {
      //  let res = { latitude: 30.585323333740234, longitude: 114.36740112304688 };
      let that = this;
      that.$wx.ready(() => {
        that.$wx.getLocation().then((res) => {
          Indicator.open({
            text: "加载中...",
            spinnerType: "fading-circle",
          });
          console.log("$wx.getLocation", res);
          // let url = `${that.$apidf.xc_voice_purchase.getLocationByGps}?latitude=${res.latitude}&longitude=${res.longitude}&fromOpenId=${that.$fopenid}&openId=${that.$openid}`;
          that.$httpdf
            .get(
              this.apiHost + 'user/getLocationByGps',
              {
                fromOpenId: this.$fopenid, //有就传，用于保存浏览记录
                openId: this.$openid,
                latitude: res.latitude,
                longitude: res.longitude,
              }
            )
            .then( async (data) => {
              Indicator.close();
              console.log("getLocationByGps---", data);
              if (data.code != 0) {
                that.$showModal("不在活动区域内");
              } else {
                console.log("GPS调取成功！");
                if (!data.data.curLocation) {
                  that.$showModal("不在活动区域内");
                  return;
                }
                Vue.prototype.$infoId = data.data.curLocation.infoId;
                // this.chooseAddress(data.data.curLocation.location)
                await this.getParticipate()
                console.log(
                  `当前城市名称--->${data.data.curLocation.location}-----当前infoId--->${data.data.curLocation.infoId}`
                );
              }
            });
        });
      });
    },
    // 参与游戏
    async getParticipate () {
      this.$util.cookie.set("infoId", this.$infoId, {
        expires: 60,
      });
      const data = await this.$httpdf.post(this.apiHost + 'user/participate')
      if (data.code == 0) {
        Vue.prototype.$key = data.data.nonceStr
        this.$util.cookie.set("key", this.$key, {
          expires: 60,
        });
        if (data.data.mobile) {
          Vue.prototype.$mobile = data.data.mobile
          this.$util.cookie.set("mobile", this.$mobile, {
            expires: 60,
          });
        }
      }else{
        if(this.timeStatus === 1){
          MessageBox.alert("活动未开始！");
        } else if (this.timeStatus === 3){
          MessageBox.alert("活动已结束！");
        } else {
          MessageBox.alert(data.msg);
        }
      }
    },
    // 倒计时
    mathTime() {
      //获取当前时间
      var now = new Date().getTime()
      //设置截止时间
      var start = this.actInfo.startTime;
      var end = this.actInfo.endTime;
      let leftTime = 0
      if (start >= now) {
        this.timeStatus = 1
        leftTime = start - now;
      } else if (now <= end){
        this.timeStatus = 2
        leftTime = end - now;
      } else {
        this.timeStatus = 3
      }
      //定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        this.countTime.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.countTime.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.countTime.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.countTime.s = Math.floor((leftTime / 1000) % 60);
      }
      //递归每秒调用mathTime方法，显示动态时间效果
      setTimeout(this.mathTime, 1000);
    },
    //我要推荐
    goShare() {
      let text = {
        text1: "因为",
        text2: "分享",
        text3: "，所以世界有了光！",
        text4: "好东西必须让更多朋友知道"
      };
      this.$modal.share.alert(text).then((res) => {
        if (res == "onSave") {
          this.$goPage("poster");
        }
      });
    },
    // 活动规则
    goRule() {
      this.infoClick(5)
      this.$goPage("rules");
    },
    // 我的奖品
    goPrize() {
      this.$goPage("myprize");
    },
    // 排行榜
    goRanking() {
      this.$goPage("birdranking");
    },
    // 参与游戏
    goGame() {
      this.infoClick(4)
      if(this.timeStatus === 1){
        MessageBox.alert("活动未开始！");
        return
      } else if (this.timeStatus === 3){
        MessageBox.alert("活动已结束！");
        return
      }
      if (!this.$infoId) {
        return this.$showModal("不在活动区域内");
      } else {
        this.$goPage("bird");
      }
    },
    //我的好友
    getFriend() {
      this.infoClick(6)
      this.showFriend = true;
    },
    //获取活动信息
    showActInfo() {
      this.$httpdf
        .get(this.apiHost + 'info/actInfo')
        .then((data) => {
          this.actInfo = data.data;
          this.mathTime(); //倒计时
        });
    },
    // 点击一键导航
    clickNav(address, coordinate) {
      this.infoClick(2)
      if (!address || !coordinate) {
        this.$showModal("没有地址或地址不正确");
        return;
      }
      this.$util.redirectTo(
        `https://uri.amap.com/marker?position=${coordinate}&name=${address}&src=mypage&coordinate=gaode&callnative=0`
      );
    },
    // 点击一键拨号
    clickCall(phone) {
      this.infoClick(1)
      this.$util.makePhoneCall(phone);
    },
    
    // 佣金排行榜
    async getCommission(){
      const data = await this.$httpdf.post(this.apiHost + `info/commission/list`)
      if (data.code == 0) {
        this.commissionList = data.data
      }
    },
    // 我的好友列表
    async getMyFrieds(){
      const data = await this.$httpdf.get(this.apiHost + `prize/myFriend`)
      if (data.code === 0) {
        this.myFriendList = data.data;
      }
    },
    // 获取游戏次数
    async getGameCount(){
      const data = await this.$httpdf.get(this.apiHost + 'user/gameCount')
      if (data.code == 0) {
        this.gameCounts = data.data.gameCount
      }
    },
    // 获取是否可以买购房券
    // async getIsReceived(){
    //   const data = await this.$httpdf.get(this.apiHost + 'order/isReceived', { prizeId: this.couponId})
    //   if (data.code == 0) {
    //     this.canBuy = data.data === 1 ? false : true
    //   }
    // },
    // 是否领取过红包
    async getIsPopUp(){
      const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/getTelFarePrizeId')
      const data1 = await this.$httpdf.get(this.apiHost + 'assistance/isPopUpPrize', { prizeId: data.data })
      if (data1.code == 0) {
        this.$modal.drawForm.alert({ prizeId: data.data, user: this.$fopenid })
      }
    },
  },
  async created() {
    this.showActInfo()
    this.chooseAddress()
    this.$route.query.status || await this.getLocationByIp(); //首先ip定位
    // this.getGameCount()
    // this.getCommission()
    // this.getMyFrieds()
    // this.getIsReceived()
    this.getIsPopUp()
  },
  async mounted() {
    window.addEventListener('scroll',this.handleScroll)
    this.$wx.shareCallBackFunList.push("share1", async() => {
      await this.$httpdf.post(this.apiHost + 'share/share');
      this.$modal.share.close()
    });
  },
  //销毁,否则跳到别的路由还是会出现
  destroyed(){
    window.removeEventListener('scroll',this.handleScroll)
  }
};
</script>

<style lang="scss" scoped>

$groupBtnTop: 230px;
$logoTop: 21px;
$personNumberTop: 9px;
$sloganTop: 25px;
$endTimeTop: 14px;
$indexBtnTop: 16px;
$prizeTop: 20px;
$couponTop: 80px;
$rankingTop: 43px;
$proTop: 32px;

// 首页盒子样子
.index-box {
  position: relative;
  box-sizing: border-box;
  width: 345px;
  // background: linear-gradient(0deg, #E9AD5E, #FCD49D);
  // border-radius: 5px;
  // padding: 5px;
  .title-bg {
    position: absolute;
    left: 50%;
    right: 0;
    top: -12px;
    transform: translateX(-50%);
    width: 106px;
    height: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-shadow: 0px 1px 2px rgba(196, 141, 82, 0.48);
    @extend .flex-center-center;
  }
}

.index {
  width: 100%;
  background: #BEDDEA url( $imgHost + 'bg.jpg?t=8') 0 0 / 100% no-repeat;
  // padding-bottom: 100px;
}

.bg {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  // 右侧导航
  .group-btn {
    position: absolute;
    right: 0;
    top: $groupBtnTop;
    z-index: 99;
    .btn-item {
      width: 57px;
      height: 20px;
      background: linear-gradient(0deg, #48C3D7 0%, #155499 100%);
      border-radius: 25px 0 0 25px;
      padding-left: 3px;
      box-sizing: border-box;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #fff;
      margin-bottom: 10px;
      @extend .flex-center-center;
    }
  }
  // logo
  .logo {
    padding-top: $logoTop;
    width: $logoWidth;
  }
  // 人数
  .person-number {
    display: flex;
    justify-content: space-between;
    padding: 0 17px;
    width: 341px;
    margin-top: $personNumberTop;
    .number-box {
      width: 110px;
      height: 18px;
      @extend .flex-center-center;
      color: rgba(255, 255, 255, 1);
      font-size: 12px;
      background: linear-gradient(90deg, #48C2D7 0%, #185A9C 100%);
      border-radius: 9px;
      text-align: center;
      span {
        &+span {
          margin-left: 5px;
        }
      }
    }
  }
  // slogan
  .slogan {
    width: $sloganWidth;
    position: relative;
    z-index: 2;
    margin-top: $sloganTop;
  }
  // 活动倒计时
  .endTime {
    text-align: center;
    margin-top: $endTimeTop;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #205380;
    label {
      display: block;
      margin-bottom: 10px;
    }
    span {
      display: inline-block;
      background: linear-gradient(0deg, #16579B 0%, #46C0D5 100%);
      border-radius: 5px;
      color: #fff;
      margin: 0 2px;
      padding: 11px 6px;
    }
  }
  // 朗读按钮
  .index_btn {
    margin-top: $indexBtnTop;
    >div {
      width: 288px;
      height: 53px;
      background: url( $imgHost + 'index_btn.png?t=8') 0 0 / 100% no-repeat;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      letter-spacing: 3px;
      text-align: center;
      line-height: 44px;
      &+div {
        margin-top: 20px;
      }
    }
  }
  // 奖品展示
  .prize-item {
    margin-top: $prizeTop;
    @extend .index-box;
    z-index: 2;
    .title-bg {
      width: 240px;
      background:url( $imgHost + 'index_title1.png?t=3') 0 center / 100% no-repeat;
      top: -20px;
    }
    .prize {
      // background: #fff;
      // border-radius: 5px;
      // padding: 20px 10px 10px; 
      text-align: center;
      p {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #A52626;
        margin-top: 15px;
      } 
    }
  }
  // 优惠券
  .coupon-item {
    margin-top: $couponTop;
    @extend .index-box;
    .title-bg {
      background:url( $imgHost + 'index_title1.png?t=3') 0 center / 100% no-repeat;
    }
    z-index: 1;
    &::after {
      content: '';
      display: block;
      width: 257px;
      height: 92px;
      background:url( $imgHost + 'index_img.png?t=3') 0 0 / 100% no-repeat;
      position: absolute;
      left: 50%;
      top: -97px;
      transform: translateX(-50%);
    }
    .prize {
      position: relative;
      padding: 15px 30px;
      .btn-coupon {
        width: 53px;
        position: absolute;
        top: 50%;
        right: 37px;
        transform: translateY(-50%);
      }
    }
  }
  // 佣金排行榜
  .ranking-box {
    margin-top: $rankingTop;
    @extend .index-box;
    background: none;
    border: 5px solid #FCD49D;
    padding: 0;
    z-index: 0;
    .title-bg {
      background:url( $imgHost + 'index_title2.png?t=3') 0 center / 100% no-repeat;
    }
    .tips {
      font-size: 14px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #FDF4E5;
      line-height: 19px;
      text-align: center;
      margin-top: 10px;
    }
    .ranking-item {
      padding: 15px 10px;
      .ranking-list {
        height: 310px;
        box-sizing: border-box;
        overflow: auto;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #F9DFC0;
        .list-item {
          display: flex;
          align-items: center;
          height: 40px;
          // background: rgba(255, 215, 151, .5);
          // border-radius: 8px;
          &+.list-item {
            margin-top: 10px;
          }
          .rank {
            width: 50px;
            text-align: center;
            position: relative;
            font-weight: 800;
            img {
              width: 18px;
            }
            span {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
            }
            label {
              display: block;
              width: 13px;
              height: 13px;
              background: #969694;
              border-radius: 50%;
              margin: 0 auto;
            }
          }
          .head-img {
            background: #fff;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            margin: 0 auto;
            position: relative;
            img {
              border-radius: 50%;
            }
          }
          .name {
            flex: 1;
            margin-left: 10px;
            span {
              font-size: 10px;
              opacity: 0.74;
            }
          }
          .score {
            margin-right: 15px; 
          }
        }
        .no-data {
          text-align: center;
          margin-top: 150px;
        }
      }
    }
  }
  // 项目展示导航
  .pro-nav {
    display: flex;
    margin-top: 24px;
    justify-content: center;
    .nav {
      width: 45px;
      height: 25px;
      line-height: 25px;
      background: linear-gradient(88deg, #FEDC45, #FB7099);
      box-shadow: 1px 2px 5px 1px rgba(48, 136, 253, 0.27);
      border-radius: 13px;
      box-sizing: border-box;
      margin: 0 6px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      text-align: center;
      color: #FFFFFF;
      &.active {
        border: 2px solid #FFFFFF;
        line-height: 21px;
      }
    }
  }
  // 项目展示列表
  .pro-box {
    margin-top: $proTop;
    @extend .index-box;
    z-index: 3;
    // background: url( $imgHost + 'project_bg.png?v=1') 0 0 / 100% no-repeat;
    .title-bg {
      background:url( $imgHost + 'index_title2.png?t=3') 0 center / 100% no-repeat;
    }
    .pro-card {
      background: rgba(110, 175, 217, .8);
      border-radius: 15px;
      text-align: center;
      padding: 20px 10px 15px;
      .pro-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        z-index: 2;
        position: relative;
        &+.pro-item {
          margin-top: 15px;
        }
        .pro-l {
          width: 160px;
          position: relative;
          // background: #fff;
          // padding: 2px;
          &.choose {
            &::after {
              display: block;
              content: '';
              width: 28px;
              height: 33px;
              background: url('https://assets.rurushishi.com/activies/hlb-purchase-20210129/click.png') center / 100% no-repeat;
              position: absolute;
              bottom: 20px;
              right: 0;
              animation: twinkle 1s infinite linear;
            }
          }
          .project-xcx {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
          }
          .project-name {
            height: 30px;
            font-size: 10px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #FB4BFB;
            text-align: right;
            margin-right: 9px;
            line-height: 30px;
          }
        }
        .pro-r {
          margin-left: 5px;
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 5px;
          >img {
            width: 106px;
          }
          .pro-name {
            display: inline-block;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #DF7726;
            position: relative;
            margin-bottom: 20px;
            &::after,&::before {
              content: '';
              display: block;
              width: 21px;
              height: 10px;
              background:url( $imgHost + 'index_icon.png?t=3') 0 0 / 100% no-repeat;
              position: absolute;
              right: 110%;
              top: 50%;
              transform: translateY(-50%);
            }
            &::before {
              right: auto;
              left: 110%;
            }
          }
          .name {
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #FFFFFF;
            margin-bottom: 10px;
          }
          span {
            display: block;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 20px;
          }
        }
      }
    }
    .pro-btn {
      margin-top: 15px;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      div {
        background: linear-gradient(0deg, #1D64A1 0%, #45C0D5 100%);
        box-shadow: 0px 0px 5px 0px rgba(9, 20, 76, 0.09);
        border-radius: 9px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #fff;
        text-align: center;
        margin: 0 auto;
        line-height: 100%;
        padding: 5px 8px;
      }
    }
    
  }
  // 我的好友
  .rule-msg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.8);
    .rule-layer {
      position: fixed;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      @extend .index-box;
      .title-bg {
        background:url( $imgHost + 'index_title2.png?t=3') 0 center / 100% no-repeat;
        z-index: 2;
      }
    }
    .rule-box {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 310px;
      background: #fff;
      padding: 15px 20px; 
      border-radius: 5px;
      box-sizing: border-box;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color:#DF7726;
      .list-item {
        display: flex;
        align-items: center;
        height: 40px;
        // background: rgba(255, 215, 151, .5);
        // border-radius: 8px;
        &+.list-item {
          margin-top: 10px;
        }
        .rank {
          width: 30px;
          font-size: 19px;
          text-align: center;
          img {
            width: 15px;
          }
        }
        .head-img {
          background: #fff;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin: 0 auto;
          position: relative;
          img {
            border-radius: 50%;
          }
        }
        .name {
          flex: 1;
          margin-left: 25px;
          span {
            font-size: 10px;
            opacity: 0.74;
          }
        }
        .score {
          margin-right: 15px; 
        }
      }
      .no-data {
        text-align: center;
        margin-top: 160px;
      }
    }
  }
  //我要推荐 一折抢购
  .btn-layer {
    position: fixed;
    bottom: 30px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
    z-index: 99;
    .left {
      width: 160px;
      height: 50px;
      background: linear-gradient(0deg, #1E67A3 0%, #47C5D7 100%);
      border-radius: 25px;
      font-size: 21px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #fff;
      letter-spacing: 2px;
      @extend .flex-center-center;
    }
  }
  // 下滑箭头
  .down-arrow {
    position: fixed;
    bottom: 180px;
    left: 0;
    right: 0;
    display:flex;
    flex-direction: column;
    justify-content :center;
    align-items :center;
    z-index: 9;
    .arrow-img{
      width:32px;
      height :32px;
    }
    .bounce{
      animation-iteration-count: infinite;
      animation-duration: 1.5s;
    }
    .down-text{
      font-size :14px;
      margin-top: 5px;
      color :#fff;
    }
  }
}

@keyframes twinkle {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(0.8);
  }
}


.xcx-box {
  position: fixed;
  top: 322px;
  right: 0;
  width: 94px;
  height: 31px;
  z-index: 9;
  background: url( $imgHost + 'icon_xcx.png?t=3') 0 0 / 100% no-repeat;
}
// 二维码
.code {
  width: 118px;
  margin-top: 20px;
}
.index_img1 {
  width: 247px;
  margin-top: 4px;
}
.index_img2 {
  width: 345px;
  margin-top: 14px;
}
.index_img3 {
  width: 100%;
  margin-top: 24px;
}
.tips {
  margin-top: 5px;
  font-size: 10px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #205380;
  text-align: center;
  line-height: 15px;
  p {
    color: #fff;
    font-size: 8px;
    font-family: Adobe Heiti Std;
    margin-bottom: 5px;
  }
}
.tips-box {
  @extend .index-box;
  background: rgba(110, 175, 217, .8) url( $imgHost + 'index_img3.png?t=3') center 10px / 160px no-repeat;;
  border-radius: 15px;
  padding: 20px 10px 15px;
  text-align: center;
  margin-top: 29px;
  .title {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #FFFFFF;
    line-height: 21px;
  }
  .content-box {
    margin-top: 35px;
    background: #98CDEF;
    box-shadow: 0px 4px 9px 0px rgba(9, 20, 76, 0.23);
    border-radius: 15px;
    position: relative;
    padding: 25px 0;
    .title-bg {
      width: 89px;
      height: 24px;
      background: url( $imgHost + 'index_title3.png?v=1') 0 0 / 100% no-repeat;
      position: absolute;
      left: 50%;
      top: -13px;
      transform: translateX(-50%);
    }
    .txt1 {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #1D64A1;
      line-height: 25px;
    }
    .txt2 {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #fff;
      line-height: 25px;
      &+.txt3 {
        margin-top: 20px;
      }
    }
    .txt3 {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 25px;
    }
    .txt4 {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #1D64A1;
      line-height: 25px;
    }
  }
}
</style>
